import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Badge, IconButton } from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { AmityUiKitChat } from "@amityco/ui-kit-open-source";
import { Client } from "@amityco/ts-sdk";
import AmityProvider from "../Bootstrap/AmityProvider";
import DialogService from "../Dialog/dialogService";
import { RootState } from "../../state";

const UserMenuMail = () => {
  const [unreadMsgCount, setUnreadMsgCount] = useState(0);
  const loginData = useSelector((state: RootState) => state.login);
  const { open } = DialogService();

  // useEffect(() => {
  //   const handleLiveObject = (
  //     liveObject: Amity.LiveObject<Amity.UserUnread | undefined>
  //   ) => {
  //     if (liveObject.data) {
  //       const { unreadCount } = liveObject.data;
  //       setUnreadMsgCount(unreadCount);
  //     }
  //   };

  //   Client.getUserUnread(handleLiveObject);
  // }, []);

  const viewMessages = () => {
    open(
      "Send New Message",
      loginData && (
        <AmityProvider>
          <AmityUiKitChat defaultChannelId={null} />
        </AmityProvider>
      ),
      []
    );
  };

  return (
    <IconButton onClick={viewMessages}>
      <Badge badgeContent={unreadMsgCount} color="secondary">
        <MailOutlineIcon sx={{ fontSize: "1.5rem !important" }} />
      </Badge>
    </IconButton>
  );
};

export default UserMenuMail;
